export const isAnswerable = ({ answered, ended_at, created_at }) => {
  if (answered || ended_at) return false;

  // Call can not be answered if it is more than 60 seconds old
  return new Date(created_at + (60 * 1000)) > new Date();
}
